module.exports = __webpack_public_path__ + "static/media/management.cc89eb2e.png";